export default __webpack_public_path__ + "static/media/hiking.45d0bbc5.png";